(function (algolia) {
  'use strict';
  algolia.translations = {
    searchTitle: `zoekresultaat`,
    search: `Huidige zoekopdracht`,
    allProducts: `bekijk alle producten`,
    matching: `passend bij`,
    sortBy: `Gesorteerd op`,
    relevance: `Relevantie`,
    outOf: `van`,
    resultsFound: `producten`,
    oneResultFound: `1 resultaat gevonden`,
    noResultFound: `Geen resultaten gevonden.`,
    addToCart: `In winkelwagen`,
    searchForProduct: `Producten zoeken`,
    selectedFilter: `Geselecteerde filters`,
    clearAll: `alles wissen`,
    outOfStock: `Niet op voorraad`,
    products: `Producten`,
    collections: `Collecties`,
    articles: `Artikelen`,
    pages: `Pagina's`,
    try: `Probeer`,
    clearFilters: `de filters te wissen`,
    or: `of`,
    changeInput: `verander je selectie`,
    showLess: `Minder tonen`,
    showMore: `Meer tonen`,
    recentlySearched: `Recent gezocht`,
    QuickView : `Snel voorbeeld`,
    showMoreText : `Meer Laden`,
    by : `van`,
  };

  algolia.translation_helpers = {
    no_result_for: function (text) {
      return 'Geen resultaat voor" ' + text + ' ".';
    },
    in: function (processingTimeMS) {
      return 'op ' + processingTimeMS / 1000 + 's';
    },

    outOf: function (page, hitsPerPage, nbHits) {
      return (
        page * hitsPerPage +
        1 +
        '-' +
        Math.min((page + 1) * hitsPerPage, nbHits) +
        ' van'
      );
    },

    by: function (text) {
      if (!text) return '';
      return ' by ' + text;
    },

    render_title: function (text, query) {
      if (text === 'Products' && query) {
        return text + ' for ' + query;
      }
      return text;
    }
  };
})(window.algoliaShopify);
